// Add future projects here; aggregation automatically includes every platform ID.
export const ARCHITECTS_MODS = [
  { curseforgeId: 1677035, modrinthId: "emi-structures" },
  { curseforgeId: 1667416, modrinthId: "adaptive-functional-storage" },
  { curseforgeId: 1679287, modrinthId: "architects-time" },
  { curseforgeId: 1683628 }, // CurseForge-only: Architects Time × Serene Seasons
];

// This value is embedded in the browser bundle. Configure it in the frontend host.
export const CURSEFORGE_API_KEY = process.env.REACT_APP_CURSEFORGE_API_KEY || "";
